<template>
  <div class="page-sidebar-wrapper">
    <div class="page-sidebar navbar-collapse collapse">
      <ul class="page-sidebar-menu page-sidebar-menu-hover-submenu sidebar-menu-ul">
        <li v-for="(item, key) in menu" :class="{'active': item.active && item.active.indexOf(route)!==-1}"
            v-bind:key="key">
          <router-link :to="{ name: item.name }">
            <i :class="item.icon"></i>
            <span class="title">{{ item.title }}</span>
            <span class="arrow" v-if="item.sub"></span>
          </router-link>
          <ul class="sub-menu" v-if="item.sub">
            <li v-for="sub_item in item.sub" v-bind:key="sub_item.name">
              <router-link :to="{ name: sub_item.name }">{{ sub_item.title }}</router-link>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  watch: {
    '$route' (to, from) {
      this.setCurrentMenu(to.name)
    }
  },
  methods: {
    setCurrentMenu (selected) {
      this.route = selected
      this.menu.forEach((item) => {
        if (item.name === selected) {
          this.current = item
        } else {
          if (item.sub && item.sub.length > 0) {
            item.sub.forEach((subItem) => {
              if (subItem.name === selected) {
                this.current = item
              } else {
                if (subItem.active && subItem.active.length > 0) {
                  subItem.active.forEach((subActiveItem) => {
                    if (subActiveItem === selected) {
                      this.current = item
                    }
                  })
                }
              }
            })
          }
        }
      })
    }
  },
  created () {
    this.setCurrentMenu(this.$route.name)
  },
  data () {
    return {
      route: null,
      current: null,
      active: null,
      menu: [
        // {
        //   name: 'home',
        //   icon: 'glyphicon glyphicon-home',
        //   title: 'Home',
        //   active: ['home']
        // },
        {
          name: 'users.listing',
          icon: 'fa fa-users',
          title: 'User Management',
          active: ['users.listing', 'users.display', 'users.form', 'users.upgrade', 'referral-codes',
            'referral-codes.edit', 'referral-codes.create', 'membership-payments', 'manage.hives', 'hives.create',
            'hive.credits', 'broadcast-notifications'],
          sub: [
            {
              title: 'Manage Users',
              name: 'users.listing'
            },
            {
              title: 'Create a user',
              name: 'users.form'
            }
          ]
        }
      ]
    }
  }
}
</script>

<style scoped>
.page-sidebar {
  width: 195px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/Side.vue